import type { ProcessActivityProfessionalSummaryData } from '@common/validation/customControls/processActivityProfessionalSummaryData';
import type { InputComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { HolterEpisodeAndJournals } from '@frontend/components/pages/episodeCategory/customControls/cardiology/holter/customComponents/HolterEpisodeAndJournals';
import { HolterLabResults } from '@frontend/components/pages/episodeCategory/customControls/cardiology/holter/customComponents/HolterLabResults';

export function getPsDataInputComponents(): InputComponentsMap<keyof ProcessActivityProfessionalSummaryData> {
    const map: InputComponentsMap<keyof ProcessActivityProfessionalSummaryData> = new Map();

    map.set('labResults', <HolterLabResults />);
    map.set('episodesAndJournals', <HolterEpisodeAndJournals />);

    return map;
}
